var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.supported)?_c('Icon',{staticClass:"eye-dropper",attrs:{"icon":"ColorPickerIcon"},on:{"click":_vm.addColor}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }